import React from 'react'
import { MDBRow, MDBCol, MDBContainer } from 'mdbreact'
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import Showdown from 'showdown'

class columnAlternatingColour extends React.Component {
  render() {
    const converter = new Showdown.Converter()

    return (
      <MDBRow className={`mx-1 alt-area ${ this.props.placement === 'right' ? 'flex-row-reverse' : '' }`} >
        <MDBCol lg="6" className="alt-right grow">
          {this.props.link.substring(0, 4) !== 'http' ?
            <Link to={this.props.link.charAt(0) != "/" ? "/" + this.props.link + "/" : this.props.link} aria-label={this.props.title} > 
              <GatsbyImage image={this.props.image} alt={this.props.alt} className="alt-bg-image" />
            </Link>
          : 
            <a href={this.props.link} target="_blank" rel="noopener" aria-label={this.props.title}>
              <GatsbyImage image={this.props.image} alt={this.props.alt} className="alt-bg-image" />
            </a>
          }
        </MDBCol>

        <MDBCol lg="6" className="alt-left bg-color">
          <div className="alt-content">
            <MDBContainer>
              <MDBRow>             
                {this.props.subtitle != null && (
                <MDBCol lg="12" className="px-0 order-last">
                  <div
                    className={ this.props.subtitleClass != null ? this.props.subtitleClass : `font-alt font-w-700 letter-spacing-1 mb-4 title-xs-medium title-large ${this.props.subtitlecolour}` }
                    dangerouslySetInnerHTML={{ __html: converter.makeHtml(this.props.subtitle) }}
                  />
                </MDBCol>
                )}

                <MDBCol lg="12" className="px-0 order-first">
                  <p className={ this.props.titleClass != null ? this.props.titleClass : 'font-alt font-w-700 letter-spacing-1 title-xs-medium title-medium text-very-dark-blue' } > {this.props.title} </p>
                </MDBCol>
              </MDBRow>
            </MDBContainer>

            <div className="mt-3 font-w-400 text-medium" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: this.props.description }} />

            {this.props.link ? (
              this.props.link.substring(0, 4) !== 'http' ? (
                <Link to={this.props.link.charAt(0) != "/" ? "/" + this.props.link + "/" : this.props.link} className={`mt-4 ${this.props.colour}`} aria-label={this.props.title} > <FontAwesomeIcon icon={faChevronRight} /> </Link>
              ) : (
                <a href={this.props.link} className={`mt-4 ${this.props.colour}`} target="_blank" rel="noopener" aria-label={this.props.title} > <FontAwesomeIcon icon={faChevronRight} /> </a>
              )
            ) : null}
          </div>
        </MDBCol>
      </MDBRow>
    )
  }
}

export default columnAlternatingColour